<template>
  <div>

  </div>
</template>

<script setup>
import {onMounted} from "vue";
import {useRouter} from "vue-router";

const router = useRouter()

onMounted(() => {
  router.push('/login')
})
</script>

<style lang="scss" scoped>

</style>